import Search from '@mui/icons-material/Search';
import { FixMe } from '@greenkub-fronts/shared/interface';
export function SearchIcon(props: FixMe) {
  return <Search {...props} />;
}

export default SearchIcon;
